import React from 'react';
import { EmailBlock, ImageBlockContent } from '../../types';

interface ImagePropertiesProps {
  block: EmailBlock;
  onUpdate: (updates: Partial<ImageBlockContent>) => void;
  mergeTags?: Array<{ name: string; value: string; sample: string }>;
  isDarkMode: boolean;
}

export const ImageProperties: React.FC<ImagePropertiesProps> = ({
  block,
  onUpdate,
  isDarkMode
}) => {
  const content = block.content as ImageBlockContent;

  return (
    <div className="space-y-4">
      <div>
        <label className={`
          block text-sm font-medium mb-1
          ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}
        `}>
          Image URL
        </label>
        <input
          type="url"
          value={content.src || ''}
          onChange={(e) => onUpdate({ src: e.target.value })}
          className={`
            w-full px-3 py-2 border rounded-md
            ${isDarkMode 
              ? 'bg-gray-700 border-gray-600 text-white' 
              : 'bg-white border-gray-300 text-gray-900'
            }
          `}
          placeholder="https://example.com/image.jpg"
        />
      </div>

      <div>
        <label className={`
          block text-sm font-medium mb-1
          ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}
        `}>
          Alt Text
        </label>
        <input
          type="text"
          value={content.alt || ''}
          onChange={(e) => onUpdate({ alt: e.target.value })}
          className={`
            w-full px-3 py-2 border rounded-md
            ${isDarkMode 
              ? 'bg-gray-700 border-gray-600 text-white' 
              : 'bg-white border-gray-300 text-gray-900'
            }
          `}
          placeholder="Image description"
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className={`
            block text-sm font-medium mb-1
            ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}
          `}>
            Width
          </label>
          <input
            type="text"
            value={content.width || '100%'}
            onChange={(e) => onUpdate({ width: e.target.value })}
            className={`
              w-full px-3 py-2 border rounded-md
              ${isDarkMode 
                ? 'bg-gray-700 border-gray-600 text-white' 
                : 'bg-white border-gray-300 text-gray-900'
              }
            `}
            placeholder="100%"
          />
        </div>

        <div>
          <label className={`
            block text-sm font-medium mb-1
            ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}
          `}>
            Height
          </label>
          <input
            type="text"
            value={content.height || 'auto'}
            onChange={(e) => onUpdate({ height: e.target.value })}
            className={`
              w-full px-3 py-2 border rounded-md
              ${isDarkMode 
                ? 'bg-gray-700 border-gray-600 text-white' 
                : 'bg-white border-gray-300 text-gray-900'
              }
            `}
            placeholder="auto"
          />
        </div>
      </div>

      <div>
        <label className={`
          block text-sm font-medium mb-1
          ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}
        `}>
          Alignment
        </label>
        <select
          value={content.align || 'center'}
          onChange={(e) => onUpdate({ align: e.target.value as any })}
          className={`
            w-full px-3 py-2 border rounded-md
            ${isDarkMode 
              ? 'bg-gray-700 border-gray-600 text-white' 
              : 'bg-white border-gray-300 text-gray-900'
            }
          `}
        >
          <option value="left">Left</option>
          <option value="center">Center</option>
          <option value="right">Right</option>
        </select>
      </div>

      <div>
        <label className={`
          block text-sm font-medium mb-1
          ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}
        `}>
          Link URL (optional)
        </label>
        <input
          type="url"
          value={content.link || ''}
          onChange={(e) => onUpdate({ link: e.target.value })}
          className={`
            w-full px-3 py-2 border rounded-md
            ${isDarkMode 
              ? 'bg-gray-700 border-gray-600 text-white' 
              : 'bg-white border-gray-300 text-gray-900'
            }
          `}
          placeholder="https://example.com"
        />
      </div>

      <div>
        <label className={`
          block text-sm font-medium mb-1
          ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}
        `}>
          Border Radius
        </label>
        <input
          type="text"
          value={content.borderRadius || '0'}
          onChange={(e) => onUpdate({ borderRadius: e.target.value })}
          className={`
            w-full px-3 py-2 border rounded-md
            ${isDarkMode 
              ? 'bg-gray-700 border-gray-600 text-white' 
              : 'bg-white border-gray-300 text-gray-900'
            }
          `}
          placeholder="0px"
        />
      </div>
    </div>
  );
};
